import { z } from "zod";
import { RuleMessageType } from "../types";

// MessageObject schema
const messageObjectSchema = z.object({
  dynamicEmailMessage: z.union([z.string(), z.null()]),
  dynamicMessage: z.union([z.string(), z.null()]),
  isDynamicEmailType: z.union([z.boolean(), z.null()]),
  isDynamicMessageType: z.union([z.boolean(), z.null()]),
  isMessageActive: z.union([z.boolean(), z.null()]),
  message: z.union([z.string(), z.null()]),
  messageEmail: z.union([z.string(), z.null()]),
  messageId: z.union([z.string(), z.number()]),
  rulesId: z.union([z.string(), z.number()]),
  messageType: z.enum([
    RuleMessageType.INTERNAL,
    RuleMessageType.EXTERNAL,
    RuleMessageType.EMAIL,
  ]),
});

const ruleMessageObjectSchema = z.object({
  [RuleMessageType.INTERNAL]: messageObjectSchema,
  [RuleMessageType.EXTERNAL]: messageObjectSchema,
  [RuleMessageType.EMAIL]: messageObjectSchema,
});

export const ruleFormSchema = z.object({
  ruleName: z.string().min(1, "Please enter a rule name"),
  groupName: z.string().min(1, "Please enter a group name"),
  priority: z.number(),
  isActive: z.boolean(),
  rulesDescription: z.union([z.string(), z.null()]).optional(),
  rulesTypeId: z.string(),
  routingUserId: z.coerce.number().optional(),
  messages: ruleMessageObjectSchema,
});

export type RuleFormType = z.infer<typeof ruleFormSchema>;
export type MessageObjectType = z.infer<typeof messageObjectSchema>;
export type RuleMessageObjectType = z.infer<typeof ruleMessageObjectSchema>;
